import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandStore } from 'zustandGlobalStore'
import type { ILeadRaw } from 'src/models/lead.model'
import { ProcessingKey } from 'constants/rootConstants'
import { updateLeadWithEmail } from './updateLeadWithEmail'
import { subscriptionsApi } from 'api'

export const fetchLead = async (leadId: string): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.FETCH_LEAD)

  const cohort =
    useZustandStore.getState().lead?.cohort ||
    useZustandStore.getState().initialCohort
  const searchParams = new URLSearchParams(window.location.search)

  const response = await subscriptionsApi.getLead({ leadId, cohort })

  if (response?.data && response?.success) {
    const lead: ILeadRaw = response.data

    useZustandStore.setState({ lead })
    useZustandGlobalLocalStore.setState((state) => ({
      previousLeadId: state.previousLeadId || lead.id,
    }))

    const email = searchParams.get('email')

    if (!lead.email && email) {
      await updateLeadWithEmail({ email })
    }
  }

  if (
    !response.success &&
    (response.status === 404 || response.data.status === 'INVALID_ARGUMENT')
  ) {
    searchParams.delete('uuid')
    // use window.location.search to reload the page with updated query params
    window.location.search = `?${searchParams}`
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_LEAD)
}
